import QueryString from "qs";

import axios from "../axios";
import { BASE_URL } from "@src/utils";

import {
  IReqPartnerReviewListParams,
  IResPartnerReviewItem,
  IReqPartnerReviewDetailParams,
  IResPartnerAutoCompleteItem,
  SelectedTag,
  IResPartnerInfoForReview,
} from "./types";

// 업체의 리뷰 목록 가져오기
export const getPartnerReviewList = async (params: IReqPartnerReviewListParams) => {
  const qsParams: Omit<IReqPartnerReviewListParams, "partnerUuid"> = {
    fetchStart: params.fetchStart,
    fetchSize: params.fetchSize,
    sortType: params.sortType,
  };
  if (params.filterType) {
    qsParams.filterType = params.filterType;
  }
  const queryString = QueryString.stringify({
    ...qsParams,
  });

  const res = await axios.get<{
    item: Array<IResPartnerReviewItem>;
    total: number;
  }>(`${BASE_URL}/v4/reviews/partners/${params.partnerUuid}?${queryString}`);

  const { item, total } = res.data;

  let hasNextPage = false;
  if (total > params.fetchStart + params.fetchSize) {
    hasNextPage = true;
  }

  return {
    items: item,
    nextFetchStart: params.fetchStart + params.fetchSize,
    hasNextPage,
    total,
  };
};

// 리뷰 작성시 업체정보 조회 API
export const getPartnerInfoForReview = async (partnerUuid: string) => {
  const res = await axios.get<{ item: IResPartnerInfoForReview }>(
    `${BASE_URL}/v4/partners/${partnerUuid}`,
  );
  return res.data;
};

// 업체의 리뷰 상세 가져오기
export const getPartnerReviewDetail = async (params: IReqPartnerReviewDetailParams) => {
  const res = await axios.get<{ item: IResPartnerReviewItem }>(
    `${BASE_URL}/v4/reviews/${params.reviewId}?reviewType=${params.reviewType}`,
  );
  return res.data.item;
};

export const getPartnerAutoCompleteList = async (
  fetchSize: number,
  fetchStart: number,
  keyword: string,
) => {
  const res = await axios.get<{ item: IResPartnerAutoCompleteItem[] }>(
    `${BASE_URL}/v4/partners/auto-completes?fetchSize=${fetchSize}&fetchStart=${fetchStart}&keyword=${keyword}`,
  );
  return res.data.item;
};

export const postWeddingbookReview = async (
  partnerUuid: string,
  content: string,
  rating: number,
  tag: SelectedTag,
  images: string[],
) => {
  const bodyData: {
    rating: number;
    tag: SelectedTag;
    content?: string;
    images?: string[];
  } = {
    rating,
    tag,
  };
  if (content) {
    bodyData.content = content;
  }
  if (images.length > 0) {
    bodyData.images = images;
  }
  const res = await axios.post(`${BASE_URL}/v4/reviews/partners/${partnerUuid}`, bodyData);
  return res.data;
};

export const postBlogReview = (
  partnerUuid: string,
  blogUrl: string,
  rating: number,
  tag: SelectedTag,
) => {
  const bodyData = {
    blogUrl: blogUrl,
    rating: rating,
    tag: tag,
  };

  return axios.post(`${BASE_URL}/web/v3/20250812/partners/${partnerUuid}/blog-reviews`, bodyData);
};

export const putWeddingbookReview = async (
  communityUuid: string,
  reviewId: number,
  content: string,
  rating: number,
  tag: SelectedTag,
  images: string[],
) => {
  const bodyData: {
    communityUuid: string;
    rating: number;
    tag: SelectedTag;
    content?: string;
    images?: string[];
  } = {
    communityUuid,
    rating,
    tag,
  };
  if (content) {
    bodyData.content = content;
  }
  if (images.length > 0) {
    bodyData.images = images;
  }
  const res = await axios.put(`${BASE_URL}/v4/reviews/${reviewId}`, bodyData);
  return res.data;
};

export const deleteReview = async (reviewId: number, communityUuid: string) => {
  const res = await axios.delete(`${BASE_URL}/v4/reviews/${reviewId}`, {
    data: {
      communityUuid,
    },
  });
  return res.data;
};
